import Button from "react-bootstrap/Button";
import { LuPencilLine } from "react-icons/lu";
import { useState } from "react";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../store/store";
import { useFormik } from "formik";
import * as yup from "yup";
import { ValidationCons } from "../validation/validationConstant";
import { updateAccountDetails } from "../service/apis/auth.api";
import { setUser } from "../store/auth.store";
import { showError, showSuccess } from "../utils/Common";

const PersonalInfoScreen = () => {
  const dispatch = useDispatch();

  const [showprofile, setShowEditPersonalInformation] = useState(false);
  const handleClose = () => setShowEditPersonalInformation(false);
  const handleShow = () => setShowEditPersonalInformation(true);

  const { user } = useSelector((state: RootState) => state.authSlice);

  const personalProfileik = useFormik({
    initialValues: {
      firstName: user?.firstName || "",
      lastName: user?.lastName || "",
      emailAddress: user?.email || "",
      phone: user?.phone || "",
      bio: user?.bio || "",
    },
    validationSchema: yup.object({
      firstName: yup
        .string()
        .trim()
        .required(ValidationCons.FIRST_NAME_REQUIRED),
      lastName: yup.string().trim().required(ValidationCons.LAST_NAME_REQUIRED),
      emailAddress: yup
        .string()
        .email(ValidationCons.IS_EMAIL)
        .required(ValidationCons.EMAIL_REQUIRED),
      phone: yup
        .string()
        .matches(/^(\+\d{1,3}[- ]?)?\d{10}$/, ValidationCons.VALID_PHONE)
        .min(10, ValidationCons.VALID_PHONE)
        .max(15, ValidationCons.VALID_PHONE),

      bio: yup.string().trim().required(ValidationCons.ABOUT_REQUIRED),
    }),
    onSubmit: async (values: any) => {
      // setLoading(true);

      try {
        let bodyData = {
          firstName: values.firstName,
          lastName: values.lastName,
          email: values.emailAddress,
          phone: values.phone,
          bio: values.bio,
        };

        const response = await updateAccountDetails(bodyData);
        const successmessages = response?.message;

        if (successmessages) {
          if (successmessages !== "Profile Data") {
            showError(response && response.message);
          } else {
            handleClose();
            dispatch(setUser(response.user));
            showSuccess("Personal Information Updated successfully");
          }
        }
      } catch (error: any) {
        //   setLoading(false);
        showError(error?.message);
      }
    },
  });
  return (
    <>
      <div className="comnbrdrGap profileEdit mb-4">
        <div className="d-flex">
          <h3>Personal Information</h3>
          <button className="editbtn" onClick={handleShow}>
            <LuPencilLine /> Edit
          </button>
        </div>
        <div className="row">
          <div className="col-lg-4">
            <p>Name</p>
            <h6>
              {user?.firstName} {user?.lastName}
            </h6>
          </div>
          <div className="col-lg-4">
            <p>Email Address</p>
            <h6>{user?.email}</h6>
          </div>
          <div className="col-lg-4">
            <p>Phone Number</p>
            <h6>{user?.phone}</h6>
          </div>
        </div>
        <p>About</p>
        <h6>{user?.bio}</h6>
      </div>

      {/* Edit Personal Information model*/}
      <Modal
        show={showprofile}
        onHide={handleClose}
        animation={false}
        aria-labelledby="contained-modal-title-vcenter"
        className="editPersonalInformation"
        centered
      >
        <Modal.Body>
          <div className="findbody">
            <h3>Edit Personal Information</h3>
            <Form
              className="modalSearch"
              onSubmit={personalProfileik.handleSubmit}
            >
              <Form.Group className="mb-3">
                <Form.Label>First Name</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Makenna"
                  name="firstName"
                  onChange={personalProfileik.handleChange}
                  onBlur={personalProfileik.handleBlur}
                  value={personalProfileik.values.firstName}
                  isInvalid={
                    !!personalProfileik.errors.firstName &&
                    Boolean(personalProfileik.touched.firstName)
                  }
                />

                <Form.Control.Feedback type="invalid">
                  {typeof personalProfileik.errors.firstName === "string" &&
                    personalProfileik.errors.firstName}
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Last Name</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Levin"
                  name="lastName"
                  onChange={personalProfileik.handleChange}
                  onBlur={personalProfileik.handleBlur}
                  value={personalProfileik.values.lastName}
                  isInvalid={
                    !!personalProfileik.errors.lastName &&
                    Boolean(personalProfileik.touched.lastName)
                  }
                />

                <Form.Control.Feedback type="invalid">
                  {typeof personalProfileik.errors.lastName === "string" &&
                    personalProfileik.errors.lastName}
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Email Address</Form.Label>
                <Form.Control
                  type="email"
                  placeholder="makenna.levin@gmail.com"
                  name="emailAddress"
                  onChange={personalProfileik.handleChange}
                  onBlur={personalProfileik.handleBlur}
                  value={personalProfileik.values.emailAddress}
                  isInvalid={
                    !!personalProfileik.errors.emailAddress &&
                    Boolean(personalProfileik.touched.emailAddress)
                  }
                  readOnly
                />

                <Form.Control.Feedback type="invalid">
                  {typeof personalProfileik.errors.emailAddress === "string" &&
                    personalProfileik.errors.emailAddress}
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Phone Number</Form.Label>
                <Form.Control
                  type="tel"
                  placeholder="(555) 123-4567"
                  name="phone"
                  onChange={personalProfileik.handleChange}
                  onBlur={personalProfileik.handleBlur}
                  value={personalProfileik.values.phone}
                  isInvalid={
                    !!personalProfileik.errors.phone &&
                    Boolean(personalProfileik.touched.phone)
                  }
                />

                <Form.Control.Feedback type="invalid">
                  {typeof personalProfileik.errors.phone === "string" &&
                    personalProfileik.errors.phone}
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>About</Form.Label>
                <Form.Control
                  as="textarea"
                  placeholder="It uses a dictionary of over 200 Latin words, combined with a handful of model sentence structures, to generate Lorem Ipsum which looks reasonable. The generated Lorem Ipsum is therefore always free from repetition, injected humour, or non-characteristic words etc."
                  name="bio"
                  onChange={personalProfileik.handleChange}
                  onBlur={personalProfileik.handleBlur}
                  value={personalProfileik.values.bio}
                  isInvalid={
                    !!personalProfileik.errors.bio &&
                    Boolean(personalProfileik.touched.bio)
                  }
                />

                <Form.Control.Feedback type="invalid">
                  {typeof personalProfileik.errors.bio === "string" &&
                    personalProfileik.errors.bio}
                </Form.Control.Feedback>
              </Form.Group>
              <Button className="btn w-100" type="submit">
                Save
              </Button>
            </Form>
          </div>
        </Modal.Body>
      </Modal>
      {/* Edit Personal Information model*/}
    </>
  );
};
export default PersonalInfoScreen;
